export const colourModes = {
    gradient: 1,
    single: 2,
    individual: 3,
    mcDefault: 4
}